import React, { useEffect, useRef, useState } from "react";
import { STATS } from "../mock";

function useCountUp(target, run) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!run) return;
    const dur = 1800;
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / dur);
      const ease = 1 - Math.pow(1 - p, 3);
      setVal(Math.floor(ease * target));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [run, target]);
  return val;
}

function StatItem({ s, run }) {
  const v = useCountUp(s.value, run);
  return (
    <div className="text-center px-4">
      <div className="display text-5xl md:text-6xl font-extrabold text-white">
        {v}
        <span className="text-yellow-600">{s.suffix}</span>
      </div>
      <div className="mt-2 text-sm uppercase tracking-[0.18em] text-slate-300 font-semibold">{s.label}</div>
    </div>
  );
}

export default function Stats() {
  const ref = useRef(null);
  const [run, setRun] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setRun(true); obs.disconnect(); } },
      { threshold: 0.3 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} className="relative py-20 bg-slate-900 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <img src="https://images.unsplash.com/photo-1602193230480-7840a38eb0c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxzdGFuZGluZyUyMHNlYW0lMjByb29maW5nfGVufDB8fHx8MTc3OTc5NTQ3MXww&ixlib=rb-4.1.0&q=85" alt="" className="w-full h-full object-cover" />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-y-10 divide-yellow-700/30 md:divide-x">
        {STATS.map((s) => <StatItem key={s.label} s={s} run={run} />)}
      </div>
    </section>
  );
}
